// extracted by mini-css-extract-plugin
export default {"wrap":"MH-z","articleImagesWrap":"NH-z","articleImage":"OH-z","singleImage":"PH-z"};